module.exports = __webpack_public_path__ + "static/media/organize-events.8e42f15f.svg";